module.exports = __webpack_public_path__ + "static/media/item_5_22_comp.0020cb88.png";